export const navigateToDashboard = (navigate: (to: string) => void) => {
  navigate("/dashboard");
};
